import { createRequestHelper } from '@utils/swr'
import { type WpUserLineStatusRequest } from '../types/apiRequest'
import { type WpUserLineStatusResponse } from '../types/apiResponse'
import { type WpApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<WpApis['get']['userLineStatus'], WpUserLineStatusResponse, WpUserLineStatusRequest | null>({
  client: 'wpRelay',
  key: (params) => {
    if (!params) return null
    const { identifier } = params
    return `/dni/mu/user/line_status?identifier=${identifier}`
  },
})

export const useApiUserLineStatus = useRequest
